import localforage from "localforage"

localforage.config({
  name: "SmashEducationDB",
  storeName: "app_data",
})

const persistentStorage = {
  getItem: async (key) => {
    try {
      let value = await localforage.getItem(key)
      if (value === null) {
        const oldData = localStorage.getItem(key)

        if (oldData !== null) {
          if (process.env.REACT_APP_ENVIORNMENT !== "production") {
            console.log(`🚚 Migrando dato: ${key} de LocalStorage a IndexedDB`)
          }
          try {
            value = JSON.parse(oldData)
          } catch (e) {
            value = oldData
          }
          await localforage.setItem(key, value)
          localStorage.removeItem(key)
        }
      }

      return value
    } catch (e) {
      if (process.env.REACT_APP_ENVIORNMENT !== "production") {
        console.warn("Error en el proceso de migración/lectura:", e)
      }
      if (
        e?.name === "UnknownError" ||
        e?.message?.includes("Connection to Indexed Database server lost") ||
        e?.message?.includes("full disk")
      ) {
        if (process.env.REACT_APP_ENVIORNMENT !== "production") {
          console.warn("Intentando restaurar conexión perdida de IndexedDB...")
        }
        try {
          localforage.config({
            name: "SmashEducationDB",
            storeName: "app_data",
          })
          const fallbackValue = await localforage.getItem(key)
          if (fallbackValue !== null) return fallbackValue
        } catch (fallbackErr) {
          if (process.env.REACT_APP_ENVIORNMENT !== "production") {
            console.warn("Fallback to localStorage due to IDB failure")
          }
          const lsData = localStorage.getItem(key)
          if (lsData) {
            try {
              return JSON.parse(lsData)
            } catch (pE) {
              return lsData
            }
          }
        }
      }
      return null
    }
  },
  setItem: async (key, value) => {
    try {
      return await localforage.setItem(key, value)
    } catch (e) {
      if (process.env.REACT_APP_ENVIORNMENT !== "production") {
        console.warn("Error guardando datos:", e)
      }
      // Automatic fallback for Safari/iOS DB Daemon terminations
      if (
        e?.name === "UnknownError" ||
        e?.message?.includes("Connection to Indexed Database server lost") ||
        e?.message?.includes("full disk")
      ) {
        if (process.env.REACT_APP_ENVIORNMENT !== "production") {
          console.warn("Intentando restaurar conexión perdida de IndexedDB...")
        }
        try {
          // recreate instance explicitly mapped
          localforage.config({
            name: "SmashEducationDB",
            storeName: "app_data",
          })
          return await localforage.setItem(key, value)
        } catch (fallbackErr) {
          // If fallback fails, defer to simple localstorage to keep the app working.
          if (process.env.REACT_APP_ENVIORNMENT !== "production") {
            console.warn("Fallback to localStorage due to IDB failure")
          }
          localStorage.setItem(key, JSON.stringify(value))
        }
      }
    }
  },

  removeItem: async (key) => {
    localStorage.removeItem(key)
    return await localforage.removeItem(key)
  },
  keys: async () => {
    return await localforage.keys()
  },

  clear: async () => {
    return await localforage.clear()
  },
}

export default persistentStorage
